import React from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../../Icon';

import styles from './styles.module.styl';

const RequiredAdditionalInsuranceDataError = () => {
  return (
    <div className={styles.wrapper}>
      <Icon size={16} name="icon-info" className={styles.icon} />
      <FormattedMessage id="common.requiredInformationMissing" />
    </div>
  );
};

export default RequiredAdditionalInsuranceDataError;



// WEBPACK FOOTER //
// ./src/components/forms/InsuranceForm/components/RequiredAdditionalInsuranceDataError/index.jsx